import CommonButton from '../../atoms/CommonButton';
import * as St from './InformationModal.styles';

type InformationModalProps = {
  title: string;
  content: string;
  isVisible: boolean;
  onClose: () => void;
};

const InformationModal = (props: InformationModalProps) => (
  <St.Container
    {...props}
    footer={[
      <CommonButton key="ok" onClick={props.onClose}>
        OK
      </CommonButton>,
    ]}
  />
);

export default InformationModal;
